import { parse, isValid, format } from 'date-fns'

// Users type/paste dates as compact digits (e.g. "120925" for 12.09.2025) and expect them
// understood, but flatpickr's own parser only matches its configured format (d.m.Y) literally -
// "120925" doesn't contain the dots it's looking for, so it falls through to a loose heuristic
// that produces an unrelated date (seen in practice landing on 12.08.2033). Tried here against
// each format in turn, including digits-only ddMMyy/ddMMyyyy. date-fns has no "strict" parse
// mode, so a shorter input can silently misparse against a longer format (e.g. "12.09.25"
// against "dd.MM.yyyy" reads year "25" as 0025) - formatting the result back and comparing to
// the original input catches that, as well as impossible dates that date-fns would otherwise
// roll forward (Feb 31 -> Mar 3).
const FORMATS = ['yyyy-MM-dd', 'dd.MM.yyyy', 'dd.MM.yy', 'dd/MM/yyyy', 'dd-MM-yyyy', 'ddMMyyyy', 'ddMMyy']

export function flexibleDateFormats (displayFormat) {
  return [displayFormat, ...FORMATS.filter((dateFormat) => dateFormat !== displayFormat)]
}

export function parseFlexibleDate (dateString) {
  const text = String(dateString).trim()
  if (!text) return undefined

  for (const dateFormat of FORMATS) {
    const parsed = parse(text, dateFormat, new Date())
    if (isValid(parsed) && format(parsed, dateFormat) === text) return parsed
  }

  return undefined
}
